import IdentityProvider from './IdentityProvider';
import {getAppOrigin} from 'coreUtils/adapters/sdk';
import {createCodeVerifier, generateCodeChallenge} from '../../../commerce-api/pkce';
import {rebuildPathWithParams} from 'coreUtils/url';
import {IIdentityProviderCredentials} from '../IIdentityProvider';

/**
 * Represents LineIdentityProvider
 */
class LineIdentityProvider extends IdentityProvider {

	/**
	 * Get Redirect Url
	  * @returns {Promise} promise resolved when the sign in process ends or popup not displayed
	 */
	private async getRedirectUrl() {
		const codeVerifier = createCodeVerifier();
		const codeChallenge = await generateCodeChallenge(codeVerifier);

		return rebuildPathWithParams(this.config.authorizationUrl, {
			response_type: 'code',
			client_id: this.config.clientId,
			redirect_uri: `${getAppOrigin()}/oauthCallback?identityProvider=Line`,
			state: codeChallenge,
			scope: this.config.scopes
		});
	}

	/**
	 * Redirect to social provider login page
	 */
	async redirectToIdentityProvider() {
		const redirectUrl = await this.getRedirectUrl();

		if (redirectUrl) {
			window.location = redirectUrl as any;
		}

	}

	/**
	 * Return the provider credentials
	 * @param {object} data - data to create object credentials
	 * @returns {IIdentityProviderCredentials|null} object containing credentials
	 */
	getProviderCredentials(data: {search: URLSearchParams}): Promise<IIdentityProviderCredentials> {
		return Promise.resolve({
			providerId: 'line',
			providerData: {
				idToken: data.search.get('code'),
				redirectUrl: `${getAppOrigin()}/oauthCallback?identityProvider=Line`
			}
		});
	}
}

export default new LineIdentityProvider();
